import API from "../api";

export const getAllPatients = async () => { 
    try {
        const response = await API.get("/api/v1/panel/patients");
       
        if (!response.data.status) {
            throw new Error(response.data.message);
        } else {
            return response.data.response;
        }
    } catch (error) {
        console.error("Error en la solicitud:", error);
        throw error;
    }
};
